import { render, staticRenderFns } from "./lastPosts.vue?vue&type=template&id=466ac4b1&scoped=true"
import script from "./lastPosts.vue?vue&type=script&lang=ts"
export * from "./lastPosts.vue?vue&type=script&lang=ts"
import style0 from "./lastPosts.vue?vue&type=style&index=0&id=466ac4b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466ac4b1",
  null
  
)

export default component.exports